import React, { Component } from 'react';

import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      decimalScale={2}
      fixedDecimalScale={true}
      onValueChange={values => {
        onChange({
          target: {
            id:"budget_number",
            value: values.value,
          },
        });
      }}
      thousandSeparator
    />
  );
}
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


class ScopeInfo extends Component {
  static propTypes = {

  };
  state = {
  };

  constructor(props)
  {
    super(props);
    //Bindings
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
  }

  componentDidMount()
  {
     this.props.actions.fetchCurrencies()
    .then(res=>{
      if(res.data.currencies && res.data.currencies.length>0)
      {
        let currencies = res.data.currencies.map(currency=>{
          let w = {};
          w.unit = w.value =currency.currency;
          w.name = w.label= currency.name + '('+currency.symbol + ')';
          if(w.label==="USD($)"){
            this.setState({defaultCurrency:w})
          }
          return w;
        });
        this.setState({
          currencies: currencies, 
        });
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    this.props.handleChange({target:{value:val.value,id:'currency'}}) 
  }


  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Scope Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              style={{width: '100%'}}
              id="overall_project_product"
              label="Overall Project Product"
              multiline
              rows="4"
              defaultValue=""
              margin="normal"
              value={this.props.scope.overall_project_product}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.scope.overall_project_product}
              helperText={this.props.errores.scope.overall_project_product}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '100%'}}
              id="description"
              label="Description"
              multiline
              rows="4"
              defaultValue=""
              margin="normal"
              value={this.props.scope.description}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.scope.description}
              helperText={this.props.errores.scope.description}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Currency</InputLabel>
              <Select
                required
                id="currency"
                name="currency"
                value={this.getValueCatalog(this.state.currencies,this.props.scope.currency)===undefined?this.state.defaultCurrency:this.getValueCatalog(this.state.currencies,this.props.scope.currency)}
                onChange={this.handleChangeSelection}
                options={this.state.currencies}
                isDisabled={this.props.reviewActive}
                error={this.props.errores.scope.currency}
                errorText={this.props.errores.scope.currency}
                helperText={this.props.errores.scope.currency}
                styles={{control: (provided,state) => (this.props.errores.scope.currency ? {...provided,borderColor: 'red', } : provided)}}
              >
              </Select>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField 
              required
              id="budget_number"
              label="Budget"
              type="text"
              value={this.props.scope.budget_number}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.scope.budget_number}
              helperText={this.props.errores.scope.budget_number}
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ScopeInfo);



// WEBPACK FOOTER //
// ./src/features/home/ScopeInfo.js